// WHAT CAN BE CHANGED?
// You can change the colour of the audio element below

<template>
    <div class="fileRewatch">
        <img src="@/assets/chat/icon-wait.svg" v-if="imageSRC == null && videoSRC == null && audioSRC == null" class="fileRewatch__wait-icon"/>
        <img :src="imageSRC" v-if="imageSRC"/>
        <video :src="videoSRC" v-if="videoSRC" controls/>
        <audio :src="audioSRC" v-if="audioSRC" controls="true" preload="auto"/>
    </div>
</template>

<script>
import db from "@/firebase/firebaseInit";

export default {
    name: "FileRewatch",
    props: ["fileURL"],
    mounted() {
        if(this.fileURL !== undefined) {
            this.readFileURL(this.fileURL);
        }
    },
    data() {
        return {
            imageSRC: null,
            videoSRC: null,
            audioSRC: null
        }
    },
    methods: {
        readFileURL(input) {
            db.storage()
            .refFromURL(input)
            .getMetadata()
            .then((metadata) => {
                if (metadata.contentType.match("image/*")) {
                    // console.log("Afbeelding");
                    this.imageSRC = input;
                } else if (metadata.contentType.match("video/*")) { 
                    // console.log("Video");
                    this.videoSRC = input;
                } else if (metadata.contentType.match("audio/*")) {
                    // console.log("Audio");
                    this.audioSRC = input;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.fileRewatch {
    margin: 10px 0px 6px;

    .fileRewatch__wait-icon {
        height: 50px;
    }
    img {
        border-radius: 5px;
        height: auto;
        width: 100%;
        box-sizing: border-box;
    }
    video {
        border-radius: 5px;
        height: auto;
        width: 100%;
        box-sizing: border-box;
    }

    audio {
        max-width: 272px;
        filter: sepia(20%) saturate(70%) grayscale(1) contrast(99%) invert(12%);
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #fileRewatch {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #fileRewatch {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #fileRewatch {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #fileRewatch {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #fileRewatch {
       
    }
}
</style>